module.exports = __webpack_public_path__ + "img/iconCheckSuccess.c8a7d03c.svg";